import { env } from "../config/env";
import { authedFetch } from "../auth/auth-fetch";
import { resolveEndpoint, type MorphedReadOptions } from "../auth/morphed-client";

export interface MorphedEntity {
	id: string;
	[key: string]: unknown;
}

export async function morphedCreate(
	entityName: string,
	data: Record<string, unknown>[],
): Promise<string[]> {
	const endpoint = resolveEndpoint(entityName);
	const res = await authedFetch(`${env.MORPHED_API_URL}/${endpoint}`, {
		method: "POST",
		body: JSON.stringify(data),
		audience: "morphed",
	});
	if (!res.ok) throw new Error(`create "${entityName}" failed: ${res.status} ${await res.text()}`);
	const json = await res.json();
	return json.createdIds ?? [];
}

export async function morphedUpdate(
	entityName: string,
	id: string,
	data: Record<string, unknown>,
): Promise<string[]> {
	const endpoint = resolveEndpoint(entityName);
	const res = await authedFetch(`${env.MORPHED_API_URL}/${endpoint}`, {
		method: "PATCH",
		body: JSON.stringify({ id, ...data }),
		audience: "morphed",
	});
	if (!res.ok) throw new Error(`update "${entityName}" failed: ${res.status} ${await res.text()}`);
	const json = await res.json();
	return json.updatedIds ?? [];
}

export async function morphedDelete(
	entityName: string,
	ids: string[],
): Promise<void> {
	const endpoint = resolveEndpoint(entityName);
	const res = await authedFetch(`${env.MORPHED_API_URL}/${endpoint}`, {
		method: "DELETE",
		body: JSON.stringify({ ids }),
		audience: "morphed",
	});
	if (!res.ok) {
		// Incluir el mensaje del cuerpo (ej. cascade: "Cannot delete... referenced by N record(s)").
		let detail = "";
		try {
			const ct = res.headers.get("content-type") || "";
			if (ct.includes("application/json")) {
				const j = (await res.json()) as { error?: string; message?: string };
				detail = j.error || j.message || "";
			} else {
				detail = (await res.text()).slice(0, 300);
			}
		} catch { /* ignore */ }
		throw new Error(detail || `delete "${entityName}" failed: ${res.status}`);
	}
}

export { morphedRead, morphedCount, type MorphedReadOptions } from "../auth/morphed-client";
